module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "dialog-bounce"
    }
  }, [_c('div', {
    staticClass: "z-dialog-wrapper"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.value),
      expression: "value"
    }],
    staticClass: "z-dialog"
  }, [(_vm.title) ? _c('div', {
    staticClass: "z-dialog__header"
  }, [_c('div', {
    staticClass: "z-dialog__title",
    domProps: {
      "textContent": _vm._s(_vm.title)
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.message) ? _c('div', {
    staticClass: "z-dialog__content"
  }, [_c('div', {
    staticClass: "z-dialog__message",
    domProps: {
      "innerHTML": _vm._s(_vm.message)
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "z-dialog__footer",
    class: {
      'is-twobtn': _vm.showCancelButton && _vm.showConfirmButton
    }
  }, [_c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showCancelButton),
      expression: "showCancelButton"
    }],
    staticClass: "z-dialog__btn z-dialog__cancel",
    on: {
      "click": function($event) {
        _vm.handleAction('cancel')
      }
    }
  }, [_vm._v(_vm._s(_vm.cancelButtonText))]), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showConfirmButton),
      expression: "showConfirmButton"
    }],
    staticClass: "z-dialog__btn z-dialog__confirm",
    on: {
      "click": function($event) {
        _vm.handleAction('confirm')
      }
    }
  }, [_vm._v(_vm._s(_vm.confirmButtonText))])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-417238a1!./~/vue-loader/lib/selector.js?type=template&index=0!./packages/dialog/src/dialog.vue
// module id = 138
// module chunks = 2 3